var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45,
    x2: 45,
    y2: 90,
    gradientTransform: "translate(18.41 -12.82) rotate(20.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(-12.82 18.41) rotate(-20.3)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45,13C26.71,13,12.55,26.39,12.55,44.47A30.79,30.79,0,0,0,22.73,67.74a2.6,2.6,0,0,1,.88,1.84l.17,5.77a2.61,2.61,0,0,0,3.65,2.3l6.43-2.84a2.58,2.58,0,0,1,1.73-.13A35.48,35.48,0,0,0,45,75.92c18.27,0,32.42-13.38,32.42-31.45S63.25,13,45,13ZM25.51,53.67,35,38.56a4.88,4.88,0,0,1,7-1.3l7.57,5.68a2,2,0,0,0,2.34,0l10.24-7.77a1.54,1.54,0,0,1,2.23,2l-9.52,15.1a4.86,4.86,0,0,1-7,1.3l-7.57-5.68A1.94,1.94,0,0,0,38,48L27.74,55.72A1.54,1.54,0,0,1,25.51,53.67Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMessenger);
export default __webpack_public_path__ + "static/media/share-messenger.b018a6064dc7141290226893ff066f12.svg";
export { ForwardRef as ReactComponent };